:host {
  display: block;
}

.search-bar {
  position: relative;
  font-family: var(
    --plyr-font-family,
    'San Francisco',
    -apple-system,
    BlinkMacSystemFont,
    '.SFNSText-Regular',
    Avenir,
    'Avenir Next',
    'Helvetica Neue',
    'Segoe UI',
    Helvetica,
    Arial,
    sans-serif
  );
  font-size: 16px;
  color: #ddd;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;

  > * {
    height: 41px;
  }

  &__controls {
    display: flex;
    align-items: stretch;
    position: absolute;
    right: 0;

    svg {
      display: block;
      width: 25px;
      height: 25px;
    }
  }

  &__placeholder {
    height: 0;
    font-weight: bold;
    visibility: hidden;
    position: absolute;
    transition: none;
    white-space: nowrap;
  }

  input {
    z-index: 1;
    box-sizing: border-box;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 16px;
    transition: width 0.25s ease;
    outline: none;
    padding: 0;

    &::placeholder {
      color: #fff;
    }
  }

  &__control-prev,
  &__control-next,
  &__control-clear {
    opacity: 0;
    visibility: hidden;
    transition: 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    transform-origin: center center;
    padding: 0;
    border: 0;
    background: 0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 1;
  }

  &__control-clear {
    transform: scale(0.5);
  }

  &--is-active {
    input {
      width: 300px !important;
      padding-right: 26px;
    }

    &.search-bar--has-navigation {
      .search-bar__control-prev,
      .search-bar__control-next {
        opacity: 1;
        visibility: visible;
      }
      input {
        padding-right: 80px;
      }
    }

    .search-bar__control-clear {
      transform: scale(1);
      opacity: 1;
      visibility: visible;
      cursor: pointer;
    }
  }

  &__icon {
    width: 20px;
    height: 20px;
    flex-grow: 0;
    flex-shrink: 0;
    cursor: pointer;

    svg {
      width: 20px;
      height: 20px;
    }
  }
}
